var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"50vh"}},[(_vm.chartData)?_c('LineChartGenerator',{ref:"canvas",staticStyle:{"height":"100%"},attrs:{"chart-options":_vm.computed_chart_options,"chartData":_vm.chartData}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }